import type { AnalyticsAPI } from '../../services/analytics'
import { getShellApiInstance } from './shell-api-instance'

const track: AnalyticsAPI['track'] = (eventName, properties) =>
  getShellApiInstance().analytics.track(eventName, { ...properties, Experience: 'Shell' })

export const getShellAnalytics = () => ({ track })
